<template>
  <div v-loading="loading" class="container w-full mx-auto px-4 pb-2">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <a :href="baseUrl">{{ this.shopName }}</a></el-breadcrumb-item
      >
      <el-breadcrumb-item>{{ $t('ec-line034.title') }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="flex flex-row w-full justify-center">
      <h1 class="text-primary text-xl">{{ title }}</h1>
    </div>
    <div class="w-full mt-8">
      <p class="text-left text-black leading-normal">{{ $t('ec-line034.content.hint1') }}</p>
      <p class="text-left text-black leading-normal">{{ $t('ec-line034.content.hint2') }}</p>
    </div>
    <el-form
      v-if="isCanInputForm"
      ref="form"
      :model="form"
      :rules="rules"
      label-position="top"
      class="t-form no-required mt-8"
    >
      <el-form-item :label="$t('common.memberInformation.email')" prop="email">
        <div class="el-input el-input--suffix">
          <p class="text-left leading-normal">{{ form.email }}</p>
        </div>
      </el-form-item>
      <el-form-item :label="$t('common.memberInformation.newPassword')" prop="password">
        <el-input
          v-model="form.password"
          type="password"
          :placeholder="$t('ec-line034.content.passwordPlaceholder')"
          show-password
        />
        <div class="text-xs">{{ $t('ec-line034.content.passwordHint') }}</div>
      </el-form-item>
      <el-form-item :label="$t('common.memberInformation.confirmNewPassword')" prop="confirmPassword">
        <el-input
          v-model="form.confirmPassword"
          type="password"
          :placeholder="$t('ec-line034.content.passwordPlaceholder')"
          show-password
        />
        <div class="text-xs">{{ $t('ec-line034.content.confirmPasswordHint') }}</div>
      </el-form-item>
      <div class="w-full mx-auto text-center mt-8">
        <el-button class="submit-btn" @click="onSend">{{ $t('common.action.sendResetPass') }}</el-button>
      </div>
    </el-form>
    <div v-else>
      <p v-show="errorMessage" class="text-xl text-red">{{ errorMessage }}</p>
    </div>
  </div>
</template>
<script>
import { AuthService } from '@/services'
import BreadcrumbMixin from '@/mixins/breadcrumb'

export default {
  mixins: [BreadcrumbMixin],
  data() {
    const confirmPasswordRule = (rule, value, callback) => {
      if (value && value !== this.form.password) {
        callback(
          new Error(
            this.$t('common.validate.cmn-err-015', [
              this.$t('common.memberInformation.newPassword'),
              this.$t('common.memberInformation.confirmNewPassword'),
            ])
          )
        )
      } else {
        callback()
      }
    }

    return {
      title: this.$t('ec-line034.title'),
      form: {
        email: '',
        password: '',
        confirmPassword: '',
        uid: '',
        token: '',
      },
      rules: {
        password: [
          this.Utils.validate.required(this.$t('common.memberInformation.newPassword')),
          this.Utils.validate.password(this.$t('common.memberInformation.newPassword')),
        ],
        confirmPassword: [
          this.Utils.validate.required(this.$t('common.memberInformation.confirmNewPassword')),
          { validator: confirmPasswordRule, trigger: ['blur'] },
        ],
      },
      loading: false,
      isCanInputForm: false,
      errorMessage: '',
    }
  },
  created() {
    this.checkParams()
  },
  methods: {
    checkParams() {
      this.loading = true
      const url = new URL(decodeURIComponent(window.location.href))

      const query = url.searchParams
      const { token, uid } = { token: query.get('token'), uid: query.get('uid') }

      if (!token || !uid) {
        this.isCanInputForm = false
        this.errorMessage = 'Invalid path'
        return
      }

      AuthService.verify({ token, uid, provider: this.Constants.PROVIDER.CUSTOMER })
        .then(({ data }) => {
          this.form.email = data.email
          this.form.uid = uid
          this.form.token = token
          this.isCanInputForm = true
        })
        .catch((error) => {
          this.isCanInputForm = false
          this.errorMessage = error.response.data.meta.message
        })
        .finally(() => (this.loading = false))
    },
    onSend() {
      this.$refs.form.validate((valid) => {
        if (!valid) return

        AuthService.resetPasswordConfirm({
          provider: this.Constants.PROVIDER.CUSTOMER,
          uid: this.form.uid,
          token: this.form.token,
          new_password: this.form.password,
          email: this.form.email,
        })
          .then(() => this.$router.push(this.$routePage.EC_LINE035))
          .catch((error) => (this.errorMessage = error.response.data.meta.message))
      })
    },
    onBack() {
      this.$router.push(this.$routePage.EC_LINE031)
    },
  },
  metaInfo() {
    return {
      title: this.title,
    }
  },
}
</script>
<style lang="scss" scope></style>
